import seq from "seq-logging";
import { loggerServerUrl } from "src/shared/loggerServerUrl";

export const sendLog = (error) => {
  // try {
  //   let logger = new seq.Logger({
  //     serverUrl: loggerServerUrl,
  //     apiKey: "XV61hii545zIF6EUdes9"
  //   });
  //
  //   logger.emit({
  //     timestamp: new Date(),
  //     level: "Error",
  //     messageTemplate:
  //       typeof error === "string"
  //         ? error
  //         : error
  //         ? typeof error.getMessage === "function"
  //           ? error.getMessage()
  //           : error.message
  //         : "Undefined error",
  //     properties: {
  //       User: JSON.parse(localStorage.getItem("user")),
  //       Application: "ControlPanel"
  //     }
  //   });
  //
  //   logger.close();
  // } catch (e) {}
};
